let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2JHKX")).then(() => parcelRequire('4wo9L'));